/**
 * The admin API surface.
 *
 * These mirror what `apps/backend` actually returns, field for field. Two
 * conventions worth knowing before reading further:
 *
 * - **Money is a decimal string**, never a number. `Prisma.Decimal` serialized
 *   to JSON is an object, and coercing it to a float is how a price loses a
 *   cent. `null` means "not priced yet" and is not the same as `"0.00"`.
 * - **Localized fields arrive as `{ ar, en }` pairs**, not one resolved string.
 *   An editor has to see which language is missing.
 */
// ----------------------------------------------------------------- settings
export const SOCIAL_PLATFORMS = [
    'instagram',
    'facebook',
    'tiktok',
    'x',
    'youtube',
    'snapchat',
    'other',
];
//# sourceMappingURL=admin.js.map